"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

(function ($) {
  window.DSSuit = {};
  window.DSSuit.fix_et_db_et_boc_body_css = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var $style, fixedText;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            try {
              $style = $("#et-builder-module-design-cached-inline-styles");
              fixedText = $style.text().replace(/\.et-db #et-boc body/g, "body");
              $style.text(fixedText);
            } catch (error) {
              console.log("Battle Suit for Divi failed to fix the broken css", error);
            }

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  window.DSSuit.dss_lightbox_on_blurb = function (selector) {
    if (typeof $.magnificPopup === "undefined") {
      // console.log("MagnificPopup has not yet loaded. Re-trying in 300ms");
      setTimeout(function () {
        window.DSSuit.dss_lightbox_on_blurb(selector);
      }, 500);
      return;
    }

    try {
      var $module = $(selector.split(" ").join("."));
      var $image = $module.find(".et_pb_image_wrap img");
      var url = $image.attr("src");
      $image.magnificPopup({
        type: 'image',
        items: {
          src: url
        }
      });
    } catch (error) {
      console.log("Error while setting up lightbox on blurb", error);
    }
  };

  $.fn.dss_hover_link_double_tap = function (params) {
    if (!('ontouchstart' in window) && !navigator.msMaxTouchPoints && !navigator.userAgent.toLowerCase().match(/windows phone os 7/i)) return false;
    this.each(function () {
      var curItem = false;
      $(this).on('click', function (e) {
        var item = $(this);

        if (item[0] != curItem[0]) {
          e.preventDefault();
          curItem = item;
        }
      });
      $(document).on('click touchstart MSPointerDown', function (e) {
        var resetItem = true,
            parents = $(e.target).parents();

        if ($(e.target)[0] == curItem[0]) {
          return;
        }

        for (var i = 0; i < parents.length; i++) {
          if (parents[i] == curItem[0]) {
            resetItem = false;
          }
        }

        if (resetItem) curItem = false;
      });
    });
    return this;
  };

  $.fn.dss_masonry_gallery = function (params) {
    var $this = $(this);

    if (typeof $.magnificPopup === "undefined") {
      setTimeout(function () {
        $this.dss_masonry_gallery(params);
      }, 300);
      return;
    }

    var masonry = $this.masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      percentPosition: true
    });
    $this.find('.grid-item a').magnificPopup({
      type: 'image',
      removalDelay: 500,
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        tCounter: '%curr% / %total%'
      },
      mainClass: 'mfp-fade',
      zoom: {
        enabled: true,
        duration: 500,
        opener: function opener(element) {
          return element.find('img');
        }
      },
      autoFocusLast: false,
      image: {
        verticalFit: true,
        titleSrc: function titleSrc(item) {
          var title = "";

          if (item.el.attr('data-title')) {
            title += item.el.attr('data-title');
          }

          if (item.el.attr('data-caption')) {
            title += "<small class='dss_masonry_gallery_caption'>" + item.el.attr('data-caption') + "</small>";
          }

          return title;
        }
      }
    });
    var layout = $.debounce(250, function () {
      masonry.masonry('layout');
    });

    if ($this.attr("data-lazy") === "true") {
      var observer = new MutationObserver(layout);
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      };
      observer.observe($this[0], config);
    }

    masonry.imagesLoaded().progress(layout);
    return masonry.masonry('layout');
  };

  $(document).ready(function () {
    $(".dss_bucket .dss_bucket_link").dss_hover_link_double_tap();
    $(".dss_masonry_gallery").each(function () {
      $("." + $(this).attr("class").replace(/ /g, ".") + " .grid").dss_masonry_gallery();
    });
    window.DSSuit.fix_et_db_et_boc_body_css();
  });
})(jQuery);